import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { lazily } from 'react-lazily';
const { BottomSheet: SpringBottomSheet } = lazily(() =>
  import('react-spring-bottom-sheet')
);

import { SVGIcon } from 'common/components';
import { useClassName } from 'common/hooks';

import 'react-spring-bottom-sheet/dist/style.css';
import './bottom-sheet.less';

const BottomSheet = ({
  isOpen,
  onClose,
  title,
  content,
  footer,
  onBack,
  addon,
  className: extraClassName,
}) => {
  const className = useClassName('BottomSheet');

  return (
    <Suspense fallback={null}>
      <SpringBottomSheet
        open={isOpen}
        onDismiss={onClose}
        initialFocusRef={false}
        className={[className('container'), extraClassName]
          .filter(Boolean)
          .join(' ')}
        footer={footer}
        header={
          <div className={className('header')}>
            {addon}
            {Boolean(onBack) && (
              <div className={className('back')} onClick={onBack}>
                <SVGIcon name="angle-left" />
              </div>
            )}
            <h4>{title}</h4>
            <div className={className('close')} onClick={onClose}>
              <SVGIcon name="close" />
            </div>
          </div>
        }>
        {content}
      </SpringBottomSheet>
    </Suspense>
  );
};

BottomSheet.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  title: PropTypes.any,
  content: PropTypes.any,
  footer: PropTypes.any,
  className: PropTypes.string,
};

export default BottomSheet;
